import * as React from 'react';

import {AccountScreens, columnListFor, programFilterFor, screenComponentFor} from './screens';
import {StudentTab} from './studentTabs';
import {StudentTheme} from './studentTheme';

interface Props {
  tab: StudentTab;
  theme: StudentTheme;
  screens?: AccountScreens | null;
}

export const StudentScreen: React.FC<Props> = ({tab, theme, screens}) => {
  const Componente = screenComponentFor(tab.screen);

  return (
    <section className="student-screen">
      <header className="student-screen__header">
        <i className={`fa-light ${tab.icon} student-screen__icon`} style={{color: theme.primary}} aria-hidden="true" />
        <h1 className="student-screen__title">{tab.label}</h1>
      </header>

      {Componente ? (
        <Componente
          theme={theme}
          programFilter={programFilterFor(tab.screen, screens)}
          columnList={columnListFor(tab.screen, screens)}
          screens={screens}
        />
      ) : (
        // A navegacao por conta ja funciona para toda aba; o conteudo e que
        // ainda nao foi portado tela a tela.
        <p className="student-screen__hint" style={{color: theme.neutral}}>
          Tela ainda não implementada.
        </p>
      )}
    </section>
  );
};
